import { css } from "emotion";

export const mainContentStyles = {
  container: css({
    height: "100%",
    flexGrow: 1,
    borderRadius: "var(--space-8)",
    display: "flex",
    flexDirection: "column"
  }),
  row: css({
    "&:not(:last-child)": {
      borderBottom: "1px solid var(--colors-neutral-400)"
    }
  }),
  paddingLeft: css({
    paddingLeft: "var(--space-8)"
  }),
  paddingX: css({
    paddingLeft: "var(--space-8)",
    paddingRight: "var(--space-8)"
  }),
  paddingY: css({
    paddingBottom: "var(--space-8)",
    paddingTop: "var(--space-8)"
  }),
  loadingLayout: css({
    overflow: "hidden"
  }),

  listContainer: css({
    flex: 1,
    overflow: "hidden",
    borderRadius: "var(--space-8)"
  }),

  highlight: css({
    background: "inherit",
    color: "var(--colors-neutral-800)"
  }),
  borderBottom: css({
    borderBottom: "1px solid var(--colors-neutral-400)"
  }),

  option: css({
    margin: "var(--space-4) 0",
    borderRadius: "var(--space-4)",
    "&:focus-visible": {
      outline: "1px solid var(--colors-neutral-700)"
    }
  }),
  buttonContainer: css({
    "& button": {
      padding: "var(--space-4) !important"
    }
  }),
  rowHeading: css({
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "0.5rem 0.75rem",
    "&:hover": {
      backgroundColor: "var(--colors-neutral-100)"
    }
  })
};
